import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ImageWrapper = styled.div`
  padding: 0px ${Spacing.S4};
`
